module.exports = __webpack_public_path__ + "img/withdrawal-success.a0994779.svg";